/*
	Aprobaciones por WappTeam (docs/CONTRATO_PROMO_EN_CAMINO.md §2). Caja arma una acción que le sube el precio a otra persona o quita
	una beca; la Supervisión de Caja / Dirección de Ventas la aprueba con un botón en WappTeam. El objeto es genérico: cada `kind`
	solo cambia el texto de `kindName` y de `lines`, así que la tarjeta no sabe nada de promociones.
*/
export type AprobacionEstado = "pendiente" | "aprobada" | "rechazada" | "retirada" | "sinAprobar" | "caducada";

export interface AprobacionLinea {
	/** Persona a la que le toca este renglón (puede venir vacío en acciones de una sola persona). */
	person?: string | null;
	text: string;
	/** A esta persona le sube algo: se pinta de rojo. */
	up?: boolean;
}
export interface AprobacionPersona { id: number; name: string }

export interface Aprobacion {
	id: number;
	kind: string;
	kindName: string;
	status: AprobacionEstado;
	statusName: string;
	campusId: number;
	studentId: number | null;
	studentName: string | null;
	enrollmentId: number | null;
	summary: string | null;
	lines: AprobacionLinea[];
	reason: string | null;
	requestedBy: AprobacionPersona | null;
	requestedAt: string | null;
	decidedBy: AprobacionPersona | null;
	decidedAt: string | null;
	decisionReason: string | null;
	canDecide: boolean;
	canWithdraw: boolean;
	/** «Enviar Otro Recordatorio»: cuántos mandó quien la pidió, cuándo el último y si el que mira puede mandar otro. */
	reminders?: number;
	lastReminderAt?: string | null;
	canRemind?: boolean;
	/** Ruta de la ficha: el contrato dice «/accountStatement?alumno=…&matricula=…»; la ruta real es /statement (ver fichaLink). */
	link: string | null;
}

export const MIN_MOTIVO = 10;

/**
 * La ruta a la que lleva «Ver en la Ficha». La ruta real del Estado de Cuenta es /statement?alumno=&plantel= (la que ya usa
 * «Abrir Completo»); si el servidor manda la del contrato (/accountStatement) se traduce, y el plantel se completa si falta.
 */
export const fichaLink = (a: Pick<Aprobacion, "link" | "campusId" | "studentId">): string => {
	const base = a.link || (a.studentId ? "/statement?alumno=" + a.studentId : "/statement");
	const [ruta, query = ""] = base.split("?");
	const params = new URLSearchParams(query);
	if (!params.has("plantel") && a.campusId) params.set("plantel", String(a.campusId));
	const destino = /^\/accountStatement\/?$/i.test(ruta) ? "/statement" : ruta;
	return destino + "?" + params.toString();
};

/** Los kinds de la fase 2 (CONTRATO §4): el mismo mecanismo, cada uno con el cuerpo de su endpoint de hoy en `data`. */
export type AprobacionKind = "eximir_meses" | "eximir_recargo" | "anular_acuerdo" | "excepcion_promo" | "caso_grupo"
	| "cambiar_vencimiento" | "cambiar_precio" | "descuento_especial" | "cambio_promo";

/** POST aprobaciones/_preview. */
export interface AprobacionPreview {
	lines: AprobacionLinea[];
	summary: string | null;
	/** Algo impide hacerlo (texto del servidor). */
	blocked: string | null;
	needsApproval: boolean;
	/** Quien lo pide ya puede hacerlo directo: se aplica como hoy. */
	canDoDirect: boolean;
	previewHash: string;
}

/** POST aprobaciones. */
export interface AprobacionCreada {
	result: "aplicado" | "porAprobar";
	text: string;
	approval: Aprobacion | null;
}
